import React from 'react';
import { Modal } from 'antd';
import { useFormContext } from 'react-hook-form';
import { AlertSuccess } from '../../../../util/Alert';
import { useQueryClient } from '@tanstack/react-query';
import fitSurveyServices from '../../../../../services/fit-survey.services';
import LegacySurveyForm from '../form/LegacySurveyForm';
import moment from 'moment';

const LegacySurveyModal = ({ open, handleClose }) => {
  const { watch, handleSubmit } = useFormContext();
  const queryClient = useQueryClient();

  const { mutate: createLegacySurvey } =
    fitSurveyServices.useMutationCreateLegacySurvey(() => {
      queryClient.invalidateQueries({
        queryKey: ['get-legacy-survey'],
        refetchType: 'all',
      });
      AlertSuccess('เพิ่มข้อมูลสำเร็จ');
      handleClose();
    });

  const { mutate: editLegacySurvey } =
    fitSurveyServices.useMutationUpdateLegacySurvey(() => {
      queryClient.invalidateQueries({
        queryKey: ['get-legacy-survey'],
        refetchType: 'all',
      });
      AlertSuccess('แก้ไขข้อมูลสำเร็จ');
      handleClose();
    });

  const _HandleSubmit = handleSubmit((data) => {
    const legaySurveyData = {
      imageUrl: data.imageUrl,
      title: data.title,
      description: data.description,
      startDate: moment(data.startDate).toDate(),
      endDate: moment(data.endDate).toDate(),
      display: true,
      memberType: data.memberType,
    };

    if (watch('formType') === 'create') {
      createLegacySurvey(legaySurveyData);
    } else if (watch('formType') === 'edit') {
      editLegacySurvey({ id: data.id, data: legaySurveyData });
    }
  });

  return (
    <Modal
      title={
        watch('formType') === 'create' ? 'เพิ่มแบบสอบถาม' : 'แก้ไขแบบสอบถาม'
      }
      visible={open}
      onCancel={handleClose}
      okText="บันทึก"
      cancelText="ยกเลิก"
      onOk={_HandleSubmit}
      width={'50vw'}
    >
      <LegacySurveyForm />
    </Modal>
  );
};

export default LegacySurveyModal;
